import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import s from './InputHint.scss';
/** Some muted text that's meant to be included after an input field. */
var InputHint = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("span", __assign({ className: c(s['root'], className) }, rest), children));
};
InputHint.displayName = 'InputHint';
export default InputHint;
//# sourceMappingURL=InputHint.js.map